// extracted by mini-css-extract-plugin
export var editButton = "footer-module--edit-button--d127f";
export var footer = "footer-module--footer--d3228";
export var footerBottom = "footer-module--footer-bottom--a6349";
export var footerContent = "footer-module--footer-content--917e0";
export var footerLinks = "footer-module--footer-links--14845";
export var footerRss = "footer-module--footer-rss--1ad76";
export var footerSocial = "footer-module--footer-social--7f2a5";
export var goToHead = "footer-module--go-to-head--644c9";